import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    html {
        box-sizing: border-box;
        scroll-behavior: smooth;
    }
    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }
    iframe,
    embed {
        border: none;
        max-width: 100%;
    }
    body {
        margin: 0;
        overflow-x: hidden;
    }
    img,
    video {
        max-width: 100%;
        height: auto;
    }
    // This is needed for product nav to align with top nav
    // The misalignment is caused by the "box-sizing: border-box" style above
    #pfs-product-nav-wrapper > :first-child {
        @media (min-width: 1024px) {
            margin-top: -1px;
        }
    }
`;

export default GlobalStyle;
